module.exports = __webpack_public_path__ + "media/images/iconDown__inFrontOfAccent--dark-47c2a4be1c670f65c5c34c06397fa385.png";